import { render, staticRenderFns } from "./LongShortType.vue?vue&type=template&id=4b2ca13f&"
import script from "./LongShortType.vue?vue&type=script&lang=ts&"
export * from "./LongShortType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports